module.exports = __webpack_public_path__ + "img/cpjs14.ce0b2e1c.png";